module.exports = __webpack_public_path__ + "390f77604fc8b88ff4404125841f5d0c.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-en.html
// module id = 940
// module chunks = 0